/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wb_TInputs */

const en_tut_wb_t = /** @type {(inputs: Tut_Wb_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared whiteboards`)
};

const id_tut_wb_t = /** @type {(inputs: Tut_Wb_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Papan tulis bersama`)
};

/**
* | output |
* | --- |
* | "Shared whiteboards" |
*
* @param {Tut_Wb_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wb_t = /** @type {((inputs?: Tut_Wb_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wb_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wb_t(inputs)
	return en_tut_wb_t(inputs)
});